/**
 * Primary conversion target for every activation CTA. Routes to the shared
 * contact dialog through the existing `#waitlist` hash on every deployment.
 */
export const WAITLIST_HREF = "#waitlist";
export const NEWSLETTER_HREF = "#newsletter";
export const PARTNER_HREF = "https://go.mlx.systems/partners";

/**
 * The home's two sections the site's menus name: "Why a Twin" is the Twin
 * story, "How it works" the match a person decides and the agreed meaning
 * after it. The nav, the footer and the home's own bands take them from
 * here, so one label leads to one section wherever it is used.
 */
export const WHY_A_TWIN_ID = "platform";
export const HOW_IT_WORKS_ID = "how-it-works";
export const WHY_A_TWIN_HREF = `/#${WHY_A_TWIN_ID}`;
export const HOW_IT_WORKS_HREF = `/#${HOW_IT_WORKS_ID}`;
